// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25O5B","productName":"Table_productName__2voKJ"};